import { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import peticionBack from "../../libs/peticiones/peticionBack";
import { Panel } from "rsuite";
import { Row, Col } from "react-bootstrap";
import { toaster } from "rsuite";
import FormSearch from "./FormSearch";
import TableElasticSearch from "./TableElasticSearch";
import createURL from "../../libs/peticiones/url";
import { ModalVideo } from "./components/ModalVideo";
import Alert from "../notification/Alert";

import "./searchStyles.css";

const formSchema = Yup.object().shape({
    textToSearch: Yup.string().required("Seleccione el texto a buscar"),
});

export default function SearchView({ typeDocument, className, amnistia = false, setTypeDocument }: { typeDocument?: string; className?: string; amnistia?: boolean; setTypeDocument?: Function }) {
    const [refresh, setRefresh] = useState<boolean>(false);
    const [searching, setSearching] = useState<boolean>(false);
    const [textSearched, setTextSearched] = useState<string>("");
    const [showForm, setShowForm] = useState<boolean>(false);
    const [showModalVideo, setShowModalVideos] = useState<boolean>(false);
    const [typeSearch, setTypeSearch] = useState<"terms" | "match">("match");

    const { handleSubmit, handleReset, handleBlur, setFieldValue, values, errors, touched, resetForm } = useFormik({
        initialValues: {
            textToSearch: "",
            startDate: "",
            endDate: "",
            addDates: false,
            sistema: "",
            instancia: "",
            delito: "",
            distrito: "",
            area: "",
            subject: "",
            folderType: "",
            tag: "",
            childhood: false,
            genre: false,
            relevantCase: false,
            isExecutorDate: false,
            intercultural: false,
            searchWithPerspectives: false,
            olderPerson: false,
            handicappedPerson: false,
            migrant: false,
            sexual: false,
            typeDocument: typeDocument || "SENTENCIA",
            year: "",
            number: "",
            epoch: "",
            jurisprudenceType: "",
        },
        validationSchema: formSchema,
        onSubmit: (values) => {
            if (values.searchWithPerspectives) {
                if (validateOneIsActive()) {
                    setSearching(true);
                    setRefresh(true);
                    setTextSearched(values.textToSearch);
                } else {
                    toaster.push(
                        Alert({
                            type: "warning",
                            message: "Active almenos una perspectiva",
                        }),
                        {
                            placement: "topEnd",
                        },
                    );
                }
            } else {
                setSearching(true);
                setRefresh(true);
                setTextSearched(values.textToSearch);
            }
        },
        onReset: () => {},
    });

    const currentDoc = (typeDocument ? typeDocument : values.typeDocument) || "ACUERDOS";

    function onChange({ target }: { target: any }) {
        if (target.name === "startDate") {
            setFieldValue("endDate", "");
        }
        setFieldValue(target.name, target.value);
    }

    async function getData(records: number, page: number) {
        let params: Array<{ name: string; value: string | number }> = [
            { name: "search", value: values.textToSearch },
            { name: "type_search", value: typeSearch },
            {
                name: "type_document",
                value: typeDocument ? typeDocument : values.typeDocument,
            },
            { name: "size", value: records },
            { name: "from", value: page },
        ];

        if (amnistia) {
            params.push({ name: "folder_type", value: values.folderType });
        }

        if (showForm) {
            if (values.sistema) {
                params.push({ name: "system", value: values.sistema });
            }
            if (values.instancia) {
                params.push({ name: "instancia", value: values.instancia });
            }
            if (values.delito) {
                params.push({ name: "judgments", value: values.delito });
            }
            if (values.startDate) {
                params.push({ name: "start_date", value: values.startDate });
            }
            if (values.endDate) {
                params.push({ name: "end_date", value: values.endDate });
            }
            if (values.distrito) {
                params.push({ name: "district", value: values.distrito });
            }
            if (values.area) {
                params.push({ name: "area", value: values.area });
            }
            if (values.subject) {
                params.push({ name: "subject", value: values.subject });
            }
            if (values.folderType && !amnistia) {
                params.push({ name: "folder_type", value: values.folderType });
            }
            if (values.tag) {
                params.push({ name: "tag", value: values.tag });
            }
            // if (values.tag) {
            //   params.push({ name: "tag", value: values.tag });
            // }
            if (values.number) {
                params.push({ name: "number", value: values.number });
            }
            if (values.year) {
                params.push({ name: "year", value: values.year });
            }
            if (values.jurisprudenceType) {
                params.push({
                    name: "jurisprudence_type",
                    value: values.jurisprudenceType,
                });
            }
            if (values.isExecutorDate) {
                params.push({
                    name: "is_executor_date",
                    value: JSON.stringify(values.isExecutorDate),
                });
            }
            if (values.searchWithPerspectives) {
                params.push({
                    name: "childhood",
                    value: JSON.stringify(values.childhood),
                });
                params.push({ name: "genre", value: JSON.stringify(values.genre) });
                params.push({
                    name: "relevant_case",
                    value: JSON.stringify(values.relevantCase),
                });
                params.push({
                    name: "intercultural",
                    value: JSON.stringify(values.intercultural),
                });
                params.push({
                    name: "sexual",
                    value: JSON.stringify(values.sexual),
                });
                params.push({
                    name: "older_person",
                    value: JSON.stringify(values.olderPerson),
                });
                params.push({
                    name: "migrant",
                    value: JSON.stringify(values.migrant),
                });
                params.push({
                    name: "handicapped_person",
                    value: JSON.stringify(values.handicappedPerson),
                });
            }
        }

        const url = createURL("/files/search/elastic", params);
        return await peticionBack({}, url, "GET", false, toaster, false);
    }

    function validateOneIsActive() {
        return values.childhood || values.relevantCase || values.intercultural || values.sexual || values.olderPerson || values.migrant || values.genre || values.handicappedPerson;
    }
    return (
        <>
            {showModalVideo && <ModalVideo modal={showModalVideo} setModal={setShowModalVideos} />}

            <div className="searchViewWrapper">
                {/* TEXTO SUPERIOR */}
                <div className="searchViewIntro">
                    <h1>Sistema de búsqueda de sentencias </h1>
                    <h5>Consulta sentencias de forma rápida y precisa.</h5>
                </div>

                {/* PANEL */}
                <Panel shaded bordered bodyFill className={`searchViewPanel doc-${String(currentDoc).toLowerCase()} ${className ? className : ""}`}>
                    <div className="searchViewCard">
                        <form onSubmit={handleSubmit} onReset={handleReset}>
                            <FormSearch
                                values={values}
                                touched={touched}
                                errors={errors}
                                onChange={onChange}
                                handleBlur={handleBlur}
                                showForm={showForm}
                                setShowForm={setShowForm}
                                setFieldValue={setFieldValue}
                                typeSearch={typeSearch}
                                setTypeSearch={setTypeSearch}
                                reset={resetForm}
                                typeDocument={typeDocument}
                                setTypeDocument={setTypeDocument}
                                amnistia={amnistia}
                            />{" "}
                        </form>
                    </div>

                    <TableElasticSearch petition={getData} stateRefresh={[refresh, setRefresh]} textSearch={textSearched} searching={searching} setSearching={setSearching} />
                </Panel>
            </div>
        </>
    );
}
